import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		marginTop: THEME.spacing.sm,
	},
	row: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	modalBody: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		padding: THEME.spacing.md,
	},
	editorWrapper: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		minHeight: 80,
		padding: THEME.spacing.sm,
	},
});
